<template>
  <div>
    <div
      :class="{ ChannelsSection__Disabled: !isActivated }"
      class="ChannelsSection"
    >
      <span v-if="!isActivated" class="ChannelsSection--Title">{{
        $t('ApplicationsChannels_ChannelsBlock_Title')
      }}</span>
      <div class="ChannelsSection--Channel--Wrapper">
        <div v-for="channel in activeChannels" class="ChannelsSection--Channel">
          <icon
            :glyph="channel.icon"
            class="ChannelsSectionChannel--Icon"
          ></icon>
          <div class="ChannelsSectionChannel--TitleRow">
            <span class="ChannelsSectionChannel--Title">{{
              channel.title
            }}</span>
            <el-switch
              v-if="
                isActivated &&
                  (channel.type === 'app_push' || channel.type === 'web_push')
              "
              v-model="pushChannel"
            ></el-switch>
            <el-switch
              v-if="isActivated && channel.type === 'inbox'"
              v-model="inboxChannel"
            ></el-switch>
            <el-switch
              v-if="isActivated && channel.type === 'inapp'"
              v-model="inAppChannel"
            ></el-switch>
            <el-switch
              v-if="isActivated && channel.type === 'onsite'"
              v-model="onSiteChannel"
            ></el-switch>
          </div>
          <div v-if="isActivated" class="ChannelsSectionChannel--Buttons">
            <router-link
              v-if="
                channel.model &&
                  (channel.type === 'app_push' ||
                    channel.type === 'web_push') &&
                  pushChannel
              "
              :to="pushSettingsRoute()"
            >
              <el-button v-if="!isAppPushComplete" plain type="primary">
                {{ $t('ApplicationsChannels_Setup') }}
                <i class="el-icon-right"></i>
              </el-button>
              <el-button v-else icon="el-icon-setting" plain type="primary">
                {{ $t('ApplicationsChannels_Settings') }}
              </el-button>
            </router-link>
            <router-link
              v-if="channel.model && channel.type === 'inapp' && inAppChannel"
              :to="inappSettingsRoute()"
            >
              <el-button icon="el-icon-setting" plain type="primary">
                {{ $t('ApplicationsChannels_Settings') }}
              </el-button>
            </router-link>
            <router-link
              v-if="channel.model && channel.type === 'onsite' && onSiteChannel"
              :to="onsiteSettingsRoute()"
            >
              <el-button icon="el-icon-setting" plain type="primary">
                {{ $t('ApplicationsChannels_Settings') }}
              </el-button>
            </router-link>
            <router-link
              v-if="channel.model && channel.type === 'inbox' && inboxChannel"
              :to="inboxSettingsRoute()"
            >
              <el-button icon="el-icon-setting" plain type="primary">
                {{ $t('ApplicationsChannels_Settings') }}
              </el-button>
            </router-link>
          </div>
        </div>
      </div>
    </div>
    <div class="ChannelsSection ChannelsSection__Discover">
      <h3
        v-if="isDiscoverChannelTitleVisible"
        class="ChannelsSectionChannel--Disabled-Title"
      >
        {{ $t('ApplicationsChannels_Disabled_Channels_Title') }}
      </h3>
      <div class="ChannelsSection--Channel--Wrapper">
        <div
          v-for="channel in discoverChannels"
          class="ChannelsSection--Channel"
        >
          <icon
            :glyph="channel.icon"
            class="ChannelsSectionChannel--Icon"
          ></icon>
          <div class="ChannelsSectionChannel--TitleRow">
            <span class="ChannelsSectionChannel--Title">{{
              channel.title
            }}</span>
          </div>
          <div class="ChannelsSectionChannel--Buttons">
            <span v-if="isChannelRequested(channel.type)">{{
              $t('ApplicationsChannels_RequestIsSent')
            }}</span>
            <el-button
              v-else
              :disabled="isChannelInProgress(channel.type)"
              :loading="isChannelInProgress(channel.type)"
              plain
              @click="requestChannel(channel.type)"
            >
              {{ $t('ApplicationsChannels_TalkToSales') }}
              <i class="el-icon-right"></i>
            </el-button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { $hasCompanyChannel } from '@/core/utils/VueAcl'
import { customConfirm, projectEndpoint, projectRoute } from '@/core/helpers'
import { ApplicationTypes } from '@/modules/account/enum/ApplicationEnum'
import { inboxSettingsIos } from '@/modules/settings/enum/IosInboxDefaultSettings'
import { inboxSettingsAndroid } from '@/modules/settings/enum/AndroidInboxDefaultSettings'
import { inboxSettingsWeb } from '@/modules/settings/enum/WebInboxDefaultSettings'
import { channelRequestStatusEnum } from '@/modules/settings/enum/ChannelRequestStatusEnum'
import RestApi from '@/core/services/RestApi'

export default {
  name: 'Channels',
  data() {
    return {
      ApplicationTypes,
      inProgressChannels: []
    }
  },

  props: {
    value: {
      type: Object,
      required: true
    },
    channels: {
      type: Object,
      required: true
    }
  },
  computed: {
    activeChannels() {
      const channels = []
      Object.keys(this.allChannels).forEach(ch => {
        if (this.allChannels[ch].visible && this.allChannels[ch].active) {
          channels.push(this.allChannels[ch])
        }
      })

      return channels
    },
    discoverChannels() {
      const channels = []
      Object.keys(this.allChannels).forEach(ch => {
        if (this.allChannels[ch].visible && !this.allChannels[ch].active) {
          channels.push(this.allChannels[ch])
        }
      })

      return channels
    },
    allChannels() {
      return {
        ios_push: {
          active: this.iosPushChannelEnabled,
          visible: this.value.type === ApplicationTypes.ios,
          icon: 'app-channel-push',
          type: 'app_push',
          model: 'pushChannel',
          title: this.$t('ApplicationsChannels_ChannelsBlock_PushChannelTitle')
        },
        android_push: {
          active: this.androidPushChannelEnabled,
          visible: this.value.type === ApplicationTypes.android,
          icon: 'app-channel-push',
          type: 'app_push',
          model: 'pushChannel',
          title: this.$t('ApplicationsChannels_ChannelsBlock_PushChannelTitle')
        },
        web_push: {
          active: this.webPushChannelEnabled,
          visible: this.value.type === ApplicationTypes.web,
          icon: 'app-channel-push',
          type: 'web_push',
          model: 'pushChannel',
          title: this.$t('ApplicationsChannels_ChannelsBlock_PushChannelTitle')
        },
        inapp: {
          active: this.inAppChannelEnabled,
          visible: this.value.type !== ApplicationTypes.web,
          icon: 'app-channel-inapp',
          type: 'inapp',
          model: 'inAppChannel',
          title: this.$t('ApplicationsChannels_ChannelsBlock_InAppChannelTitle')
        },
        onsite: {
          active: this.onSiteChannelEnabled,
          visible: this.value.type === ApplicationTypes.web,
          icon: 'app-channel-onsite',
          type: 'onsite',
          model: 'inAppChannel',
          title: this.$t(
            'ApplicationsChannels_ChannelsBlock_OnSiteChannelTitle'
          )
        },
        inbox: {
          active: this.inboxChannelEnabled,
          visible: true,
          icon: 'app-channel-inbox',
          type: 'inbox',
          model: 'inboxChannel',
          title: this.$t('ApplicationsChannels_ChannelsBlock_InboxChannelTitle')
        }
      }
    },

    channelRequestEndpoint() {
      return projectEndpoint({
        method: 'post',
        url: 'channel-request'
      })
    },
    isAppPushComplete() {
      return this.value.push_setup === 1
    },
    isActivated() {
      return this.value.activated
    },

    pushChannel: {
      get() {
        return this.value.push
      },
      set(newValue) {
        this.switchChannel('push', newValue)
      }
    },

    onSiteChannel: {
      get() {
        return this.value.onsite
      },
      set(newValue) {
        if (newValue) {
          customConfirm(
            this.$t('ApplicationsChannels_EnableOnSite_Title'),
            this.$t('ApplicationsChannels_EnableOnSite_Message'),
            this.$t('ApplicationsChannels_Enable'),
            undefined,
            undefined,
            ' custom-confirm-ce'
          ).then(_ => this.switchChannel('onsite', newValue))
        } else {
          this.switchChannel('onsite', newValue)
        }
      }
    },

    inAppChannel: {
      get() {
        return this.value.inapp
      },
      set(newValue) {
        if (newValue) {
          customConfirm(
            this.$t('ApplicationsChannels_EnableInApp_Title'),
            this.$t('ApplicationsChannels_EnableInApp_Message'),
            this.$t('ApplicationsChannels_Enable'),
            undefined,
            undefined,
            ' custom-confirm-ce'
          ).then(_ => this.switchChannel('inapp', newValue))
        } else {
          this.switchChannel('inapp', newValue)
        }
      }
    },

    inboxChannel: {
      get() {
        return this.value.inbox
      },
      set(newValue) {
        if (newValue === 1 && this.value.inbox_settings === null) {
          switch (this.value.type) {
            case ApplicationTypes.ios:
              this.value.inbox_settings = { ...inboxSettingsIos }
              break
            case ApplicationTypes.android:
              this.value.inbox_settings = { ...inboxSettingsAndroid }
              break
            case ApplicationTypes.web:
              this.value.inbox_settings = { ...inboxSettingsWeb }
              break
          }
        }
        this.switchChannel('inbox', newValue)
      }
    },

    inAppChannelEnabled() {
      return $hasCompanyChannel('inapp')
    },

    onSiteChannelEnabled() {
      return $hasCompanyChannel('onsite')
    },
    inboxChannelEnabled() {
      return $hasCompanyChannel('inbox')
    },
    androidPushChannelEnabled() {
      return $hasCompanyChannel('android_push')
    },
    iosPushChannelEnabled() {
      return $hasCompanyChannel('ios_push')
    },
    webPushChannelEnabled() {
      return $hasCompanyChannel('web_push')
    },
    isDiscoverChannelTitleVisible() {
      return this.discoverChannels.length > 0 && this.activeChannels.length > 0
    }
  },

  methods: {
    requestChannel(channel) {
      const payload = {
        user_id: this.$store.state.app.user.uid,
        project_id: this.$route.query.project_id,
        channel: channel,
        application_id: this.$route.query.id
      }

      customConfirm(
        this.$t('Channels_RequestChannel_Title', {
          channel: this.$props.channels[channel].title
        }),
        this.$t('Channels_RequestChannel_Message'),
        this.$t('Channels_RequestChannel_Confirm')
      )
        .then(result => {
          if (!this.inProgressChannels.includes(channel)) {
            this.inProgressChannels.push(channel)
          }

          RestApi({
            ...this.channelRequestEndpoint,
            data: payload
          })
            .then(({ data }) => {
              if (data.id) {
                this.channels[channel].requestStatus = data.status
              }

              if (this.inProgressChannels.includes(channel)) {
                this.inProgressChannels = this.inProgressChannels.filter(
                  item => item !== channel
                )
              }
            })
            .catch(error => {
              this.$message({
                message: error.message,
                type: 'error'
              })

              if (this.inProgressChannels.includes(channel)) {
                this.inProgressChannels = this.inProgressChannels.filter(
                  item => item !== channel
                )
              }
            })
        })
        .catch(_ => {})
    },
    isChannelInProgress(channel) {
      return this.inProgressChannels.includes(channel)
    },

    isChannelRequested(channel) {
      return (
        this.channels[channel].requestStatus === channelRequestStatusEnum.NEW ||
        this.channels[channel].requestStatus ===
          channelRequestStatusEnum.IN_PROCESS
      )
    },

    switchChannel(channel, value) {
      this.$emit('switch-channel', {
        channel: channel,
        value: value
      })
    },
    pushSettingsRoute() {
      return projectRoute({
        name: 'ApplicationPush',
        query: { id: this.$route.query.id }
      })
    },
    inboxSettingsRoute() {
      return projectRoute({
        name: 'ApplicationInbox',
        query: { id: this.$route.query.id }
      })
    },
    onsiteSettingsRoute() {
      return projectRoute({
        name: 'ApplicationInapp',
        query: { id: this.$route.query.id }
      })
    },
    inappSettingsRoute() {
      return projectRoute({
        name: 'ApplicationInapp',
        query: { id: this.$route.query.id }
      })
    }
  }
}
</script>

<style scoped>
.ChannelsSection {
  margin-top: 10px;
}

.ChannelsSection__Disabled {
  margin-top: 32px;
}

.ChannelsSection--Title {
  display: block;
  margin-bottom: 16px;
  font-weight: 600;
  font-size: 16px;
  line-height: 24px;
  color: #4b515f;
}

.ChannelsSection--Channel {
  background-color: white;
  width: calc(100% * (1 / 3) - 51px);
  padding: 20px;
  min-height: 137px;
}

.ChannelsSection__Disabled .ChannelsSection--Channel {
  background: none;
}

.ChannelsSection__Disabled .ChannelsSectionChannel--Icon,
.ChannelsSection__Disabled .ChannelsSectionChannel--Title {
  color: #c2c7d3;
}

.ChannelsSection__Discover .ChannelsSectionChannel--Icon,
.ChannelsSection__Discover .ChannelsSectionChannel--Title {
  color: #5c6374;
}

.ChannelsSection--Channel {
  border-right: 1px solid #ebeef5;
}

.ChannelsSection--Channel {
  border-bottom: 1px solid #ebeef5;
}

.ChannelsSection--Channel--Wrapper {
  padding: 0;
  display: flex;
  flex-wrap: wrap;
}

.ChannelsSectionChannel--Icon {
  width: 30px;
  height: 30px;
  color: #51ade6;
}

.ChannelsSectionChannel--TitleRow {
  margin-top: 13px;
  display: flex;
  align-items: center;
}

.ChannelsSectionChannel--Title {
  font-weight: 600;
  font-size: 16px;
  line-height: 24px;
  color: #5c6374;
}

.ChannelsSectionChannel--Disabled-Title {
  color: #4b515f;
  font-weight: 600;
  font-size: 16px;
  line-height: 40px;
}

.ChannelsSectionChannel--TitleRow .el-switch {
  margin-left: 12px;
}

.ChannelsSectionChannel--Buttons {
  margin-top: 24px;
}
</style>



// WEBPACK FOOTER //
// src/modules/account/components/Channels.vue